<template>
<div class="chapter">
<div class="inner_page">
<div class="halfTitlePage" id="hlf01">
<a id="pagei"></a>
<a id="pageii"></a>
<h2 class="halfTitlePageTitle"><span class="bold">Rule Your Freakin’ Retirement</span></h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ruleyourfreakinretirement_hlf01.vue?6ca81981